import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { withAdmin } from "@/services/withAdmin";
import { IAdminFireBase } from "@/store/models/admin.models";
import { Profile } from "@/store/models/users.models";
import LikedVideos from "./components/LikedVideos/LikedVideos";
import LikedMusic from "./components/LikedMusic/LikedMusic";
import GeneratedBooks from "./components/GeneratedBooks/GeneratedBooks";
import Layout from "@/components/Layout/Layout";

const ProfileActivityPageCmp: React.FC<{ admin: IAdminFireBase }> = ({
  admin,
}) => {
  const location = useLocation();
  const profile: Profile = location.state.profile;
  const { contentType } = useParams<{ contentType: string }>();

  const renderContent = () => {
    switch (contentType) {
      case "liked videos":
        return <LikedVideos profile={profile} type="liked" />;
      case "watched videos":
        return <LikedVideos profile={profile} type="watched" />;
      case "liked songs":
        return <LikedMusic profile={profile} type="liked" />;
      case "listened songs":
        return <LikedMusic profile={profile} type="watched" />;
      case "generated books":
        return <GeneratedBooks profile={profile} />;
      default:
        return null;
    }
  };
  return (
    <Layout admin={admin}>
      <div
        style={{
          paddingTop: "20px",
        }}
      >
        {renderContent()}
      </div>
    </Layout>
  );
};

export const ProfileActivityPage = withAdmin(ProfileActivityPageCmp);
ProfileActivityPageCmp.displayName = "ProfileActivityPageCmp";

